<template>
  <div class="DefaultCheckbox">
    <div v-if="label" class="Label">
      {{ label }}
    </div>
    <div class="Container" @click="() => { this.$emit('update:modelValue', !modelValue) }">
      <div 
        class="Checkbox"
        :class="{
          Enable: modelValue,
          Disable: !modelValue
        }"
      >
        <div 
          class="Icon"
          :class="{
            EnableIcon: modelValue,
            DisableIcon: !modelValue
          }"
        >
          <svg v-if="modelValue" width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 4.00033L3.82843 6.82875L9.48468 1.17188" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-if="!modelValue" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.26683 9.66683L0.333496 8.7335L4.06683 5.00016L0.333496 1.26683L1.26683 0.333496L5.00016 4.06683L8.7335 0.333496L9.66683 1.26683L5.9335 5.00016L9.66683 8.7335L8.7335 9.66683L5.00016 5.9335L1.26683 9.66683Z" fill="#FFFFFF"/>
          </svg>
        </div>
      </div>
      <div class="Comment">
        {{ $t(modelValue ? "components.default_checkbox.enable" : "components.default_checkbox.disable") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DefaultCheckbox',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue']
};
</script>

<style scoped>
.DefaultCheckbox {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: column;
  gap: 8px;
}
.Label {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #1A1A1A;
}
.Container {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  flex-direction: row;
  gap: 4px;

  cursor: pointer;
  user-select: none;
}
.Checkbox {
  position: relative;
  display: flex;

  width: 40px;
  height: 20px;

  background: #E4FFEA;
  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.04);
  border-radius: 16px;

  transition: all 0.5s;
}
.Enable {
  background: #E4FFEA;
}
.Disable {
  background: #FFE8E9;
}
.Icon {
  position: relative;
  display: flex;

  width: 20px;
  height: 20px;

  align-items: center;
  justify-content: center;

  border-radius: 9999px;
  transition: all 0.5s;
}
.EnableIcon {
  background: #28A745;
  transform: translateX(20px) rotate(360deg);
}
.DisableIcon {
  background: #DC3545;
  transform: translateX(0px) rotate(0deg);
}
.Comment {
  position: relative;
  display: flex;

  width: fit-content;
  height: fit-content;

  font-family: 'Involve';
  font-weight: 500;
  font-size: 12px;
  line-height: 150%;
  color: #1A1A1A;
}
</style>
